import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  ConfigProvider,
  Flex,
  Card,
  Space,
  Image,
  Button,
  List,
} from "antd";
import {
  Link,
  useSearchParams,
  useOutletContext,
  useLocation,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  RightOutlined,
  WarningFilled,
  CloseOutlined,
  HistoryOutlined,
} from "@ant-design/icons";
import { setModuleClicked } from "../../../redux/features/main/searchSlice";

import { Loader } from "../../../components/Loader";
import defaultImage from "../../../assets/images/png/general/img_thumb_default.png";

import useActions from "./hooks/useActions";

import { setLocalStorage, getLocalStorage } from "../../../utils";
// for translate
import { useTranslation } from "react-i18next";

import {
  colorTextTitle,
  ColorSecondary,
  ColorPrimary,
  textTitleMyLearningJourney,
  backgroundCard,
  textDescMyLearningJourney,
  badgeDaysLeftBackground,
  badgeNewBackground,
  colorTextTitleMobile,
  ColorTertiari,
  ColorDisabled,
  colorTextDesc
} from "../../../config/constant/color/index";

import SearchMobileLearningJourney from "../../main/contents/LearningJourney/lib/SearchMobileLearningJourney";
import {
  setTextSearch,
  setSearchBarPosition,
} from "../../../redux/features/main/searchSlice";
// import i_courses from "../../../assets/images/svgs/ic_courses_programdesc.svg";

const Search = (props) => {
  const { isContentLibraryPage, mainState } = props;
  const { t, i18n } = useTranslation();

  const searchBarPosition = useSelector(
    (state) => state.search.searchBarPosition,
  );
  const dispatch = useDispatch();
  const location = useLocation();

  const isMobileVersion = props?.isMobileVersion;

  let [searchParams, setSearchParams] = useSearchParams();
  let searchVal = searchParams.get("search");

  const {
    dataAcademySearch,
    dataProgramSearch,
    dataCourseSearch,
    dataModuleSearch,
    lengthData,
    loadingAnchorSearch,
  } = useActions();

  const cardStyle = {
    margin: 0,
    maxWidth: "228px",
    lineHeight: "normal",
    textAlign: "left",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    width: "228px",
  };

  const onClickViewAll = (type) => {
    // scroll to top to prevent auto load on page detail Search
    document.getElementById("content-main").scrollTo(0, 0);

    searchParams.set("all", type);
    searchParams.set("length", lengthData[type]);
    setSearchParams(searchParams);
  };

  const linkHref = (item, cat) => {
    if (searchBarPosition === "search_mylj") {
      if (cat === "prog")
        return `/my-learning-journey/journey/${item.id}${
          isMobileVersion ? `?from=search&src=${searchVal}` : ""
        }`;
      if (cat === "cour")
        return `/my-learning-journey/journey/${item.journey_id}/course/${
          item.id
        }${isMobileVersion ? `?from=search&src=${searchVal}` : ""}`;
      if (cat === "mod") {
        if (item.isEss === 1) {
          return `/my-learning-journey/journey/${item.journey_id}/course/${
            item.course_id
          }/module/${item.id}${
            isMobileVersion ? `?from=search&src=${searchVal}` : ""
          }`;
        } else {
          return `/my-learning-journey/journey/${item.journey_id}/course/${
            item.course_id
          }/supporting/${item.id}${
            isMobileVersion ? `?from=search&src=${searchVal}` : ""
          }`;
        }
      }
    } else {
      if (cat === "aca")
        return `/content-library/academy/${item.id}${
          isMobileVersion ? `?from=search&src=${searchVal}` : ""
        }`;
      if (cat === "prog")
        return `/content-library/academy/${item.academy_id}/journey/${item.id}${
          isMobileVersion ? `?from=search&src=${searchVal}` : ""
        }`;
      if (cat === "cour")
        return `/content-library/academy/${item.academy_id}/journey/${
          item.journey_id
        }/course/${item.id}${
          isMobileVersion ? `?from=search&src=${searchVal}` : ""
        }`;
      if (cat === "mod") {
        if (item.isEss === 1) {
          return `/content-library/academy/${item.academy_id}/journey/${
            item.journey_id
          }/course/${item.course_id}/module/${item.id}${
            isMobileVersion ? `?from=search&src=${searchVal}` : ""
          }`;
        } else {
          return `/content-library/academy/${item.academy_id}/journey/${
            item.journey_id
          }/course/${item.course_id}/supporting/${item.id}${
            isMobileVersion ? `?from=search&src=${searchVal}` : ""
          }`;
        }
      }
    }
  };

  useEffect(() => {
    setLocalStorage("pageBack", null);
  }, [location]);

  const allJourneyData = props?.allJourneyData;

  const countCompletednTotal = (idJourney) => {
    // initiate count
    let c_completed = 0;
    let c_total_course = 0;

    // find journey that has same id with idJourney from listAllData Main
    const selectedJourney = allJourneyData.find(
      (dataJourney) => idJourney === parseInt(dataJourney.id),
    );

    // counting all completed and total
    selectedJourney.course.map((course) => {
      if (course.is_completed === 1) c_completed++;
      c_total_course++;
    });

    return {
      courseCompleted: c_completed,
      totalCourse: c_total_course,
    };
  };

  const countTotalCourse = (id) => {
    let datacomplete = countCompletednTotal(id); // get course completed and total course first

    return datacomplete.totalCourse;
  };

  const countCompletedModule = (idJourney) => {
    // find journey that has same id with idJourney from listAllData Main
    const selectedJourney = allJourneyData.find(
      (dataJourney) => idJourney === parseInt(dataJourney.id),
    );

    return {
      moduleCompleted: selectedJourney.module_completed,
      totalModules: selectedJourney.total_module,
    };
  };

  const checkProgressCompleteCourse = (id) => {
    let datacomplete = countCompletedModule(id); // get course completed and total course first

    return Math.round(
      (parseInt(datacomplete.moduleCompleted) /
        parseInt(datacomplete.totalModules)) *
        100,
    );
  };

  const checkProgressCompletedColor = (id) => {
    let datacomplete = countCompletedModule(id); // get course completed and total course first

    if (
      parseInt(datacomplete.moduleCompleted) >=
      parseInt(datacomplete.totalModules)
    )
      return ColorTertiari;

    return null;
  };

  const renderCardMobile = (item, index, name) => {
    const cardContent = (
      <Card
        key={index}
        data-id={index}
        style={{
          padding: 0,
          boxShadow: "3px 0 16px rgba(0, 0, 0, 0.1)",
          borderRadius: "8px",
          width: "100%",
        }}
        className="card-search-mobile"
      >
        <Row
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            textAlign: "left",
          }}
        >
          <Space
            direction={"horizontal"}
            style={{ borderRadius: "0", width: "100%", gap: "0px" }}
            className="space-learning-journey"
          >
            <div style={{ width: "100%", height: "91px" }}>
              <div
                style={{
                  display:
                    item?.days_left && item?.is_completed !== 1
                      ? "block"
                      : "none",
                }}
              >
                <div
                  style={{
                    zIndex: 1,
                    fontWeight: "bold",
                    color: "#FFFFFF",
                    background: badgeDaysLeftBackground,
                    position: "absolute",
                    left: 0,
                    top: 0,
                    fontSize: "10px",
                    padding: "4px 8px",
                    borderTopLeftRadius: "8px",
                    borderBottomRightRadius: "8px",
                  }}
                >
                  <WarningFilled style={{ color: "#FFFFFF" }} />
                  &nbsp;
                  {item?.days_left ? (
                    item?.days_left !== "overdue" ? (
                      item?.days_left > 1 ? (
                        <>
                          {item?.days_left}{" "}
                          {t("feature.feature_mylj.anchor.days_left")}
                        </>
                      ) : (
                        <>{item?.days_left} Day left</>
                      )
                    ) : (
                      <>{t("feature.feature_mylj.anchor.overdue")}</>
                    )
                  ) : null}
                </div>
              </div>
              <Image
                preview={false}
                width={"108.95px"}
                height={"91px"}
                style={{
                  objectFit: "cover",
                  borderRadius: "8px",
                }}
                src={item.thumbnail}
                fallback={defaultImage}
                alt="My learning journey Mobile Search Result"
              />
              <div style={{ display: item?.badge_new ? "block" : "none" }}>
                <div
                  style={{
                    fontWeight: "bold",
                    color: "#FFFFFF",
                    background: badgeNewBackground,
                    position: "absolute",
                    right: 0,
                    top: 0,
                    fontSize: "10px",
                    padding: "4px 8px",
                    borderTopRightRadius: "8px",
                    borderBottomLeftRadius: "8px",
                  }}
                >
                  {t("feature.feature_mylj.anchor.new")}
                </div>
              </div>
            </div>
            <Space
              direction="vertical"
              style={{
                width: "100%",
                padding: "10px 12px 0 12px",
                gap: "4px",
              }}
            >
              <div
                className="title-program"
                style={{
                  height: "32px",
                  fontSize: "14px",
                  fontWeight: "500",
                  color: textTitleMyLearningJourney,
                  textAlign: "left",
                }}
              >
                <div
                  className={
                    isMobileVersion
                      ? "break-dots-second-line"
                      : "center-vertically-and-horizontally break-dots-second-line"
                  }
                  style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    lineHeight: "normal",
                    width: "100%",
                    // left: "43%",
                  }}
                >
                  {item.name}
                </div>
              </div>
              <div
                className="desc-program break-dots-second-line"
                style={{
                  fontSize: "12px",
                  height: "32px",
                  lineHeight: "1.4",
                  color: textDescMyLearningJourney,
                  textAlign: "left",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: isMobileVersion ? "100%" : "200px",
                }}
              >
                {item.description}
              </div>
            </Space>
          </Space>
        </Row>
      </Card>
    );

    return (
      <Link
        to={linkHref(item, name)}
        data-index={index}
        key={index}
        style={{ width: "100%" }}
      >
        {cardContent}
      </Link>
    );
  };

  const handleSelectSearch = (value) => {
    dispatch(setTextSearch(value));
    setSearchParams({ search: value });
    // local Storage things to save, read, and set
    const historyValue =
      Array.isArray(getLocalStorage("search_cl")) === true
        ? getLocalStorage("search_cl")
        : JSON.parse(getLocalStorage("search_cl"));

    const arrayHistory = historyValue,
      index = arrayHistory.findIndex((v) => v === value);

    if (index !== -1) arrayHistory.unshift(...arrayHistory.splice(index, 1));

    // trim array to only 5 history
    const trimArr =
      arrayHistory.length > 5 ? arrayHistory.slice(0, 5) : arrayHistory;

    setLocalStorage("search_cl", JSON.stringify(trimArr));
  };

  const recentSearch = getLocalStorage(searchBarPosition)
    ? JSON.parse(getLocalStorage(searchBarPosition)).slice(0, 5)
    : [];

  const dynamicMarginTop = mainState.isFocusedSearch
    ? Math.min(recentSearch.length * 51 + 70)
    : 0; // 70 dari kalkulasi tinggi recent search

  return (
    <ConfigProvider
      theme={{
        token: {
          fontFamily: "Roboto",
        },
      }}
    >
      {loadingAnchorSearch ? (
        <Loader />
      ) : (
        <div
          style={{
            textAlign: "left",
            padding: isMobileVersion ? "20px 18px" : "36px 40px 25px",
            paddingTop: isMobileVersion ? 20 : 36,
            overflowY: isMobileVersion ? "auto" : "unset",
            height: isMobileVersion ? "100%" : "auto",
            marginTop: 0,
          }}
        >
          {isMobileVersion ? (
            isContentLibraryPage ? (
              <div style={{ lineHeight: "normal", marginBottom: 18 }}>
                <div
                  style={{
                    fontSize: 16,
                    lineHeight: "24px",
                    fontWeight: 500,
                    color: colorTextTitle,
                  }}
                >
                  {t("feature.feature_search.search_results")} “{searchVal}”
                </div>
              </div>
            ) : (
              <SearchMobileLearningJourney />
            )
          ) : (
            <div style={{ lineHeight: "normal", marginBottom: 31 }}>
              <div
                style={{ fontSize: 22, fontWeight: 500, color: colorTextTitle }}
              >
                {t("feature.feature_search.search_results")} “{searchVal}”
              </div>
            </div>
          )}

          <div
            style={{
              marginBottom: isMobileVersion ? 28 : 40,
              marginTop: isMobileVersion ? (isContentLibraryPage ? 0 : 20) : 0,
            }}
          >
            <div
              style={{
                fontSize: 20,
                lineHeight: "normal",
                marginBottom: dataProgramSearch.length > 0 ? 20 : 8,
                color: colorTextTitle,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  fontWeight: isMobileVersion && 400,
                  fontSize: isMobileVersion && 16,
                  color: isMobileVersion && colorTextTitleMobile,
                }}
              >
                <span
                  style={{
                    fontWeight: 500,
                    fontSize: isMobileVersion && 16,
                    color: isMobileVersion && colorTextTitleMobile,
                  }}
                >
                  {t("feature.feature_search.program")}
                </span>{" "}
                <span style={{
                  color: colorTextDesc
                }}>
                  (
                  {lengthData.program !== undefined && lengthData.program !== null
                    ? lengthData.program
                    : 0}{" "}
                  {t("feature.feature_search.found")})
                </span>
              </div>
              <div
                style={{
                  fontSize: isMobileVersion ? 14 : 16,
                  fontWeight: 500,
                  color: ColorPrimary,
                }}
              >
                <div
                  style={{
                    display:
                      lengthData.program !== undefined &&
                      lengthData.program !== null &&
                      lengthData.program > 5
                        ? "block"
                        : "none",
                  }}
                  className="btn-view-all"
                  onClick={() => onClickViewAll("program")}
                >
                  {t("feature.feature_search.view_all")}
                  {isMobileVersion && (
                    <RightOutlined
                      style={{
                        color: ColorPrimary,
                        marginLeft: "4px",
                        fontSize: 12,
                        fontaWeeight: 500,
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
            <div>
              <Flex
                className="h-100 w-100 flex-search-anchor"
                wrap="wrap"
                gap={isMobileVersion ? "16px" : "middle"}
              >
                {dataProgramSearch && dataProgramSearch.length > 0 ? (
                  dataProgramSearch &&
                  dataProgramSearch.map((itemProgram, indexProgram) =>
                    isMobileVersion ? (
                      props?.loadingAllJourney ? (
                        <Loader />
                      ) : (
                        renderCardMobile(itemProgram, indexProgram, "prog")
                      )
                    ) : (
                      <Card
                        key={indexProgram}
                        bordered={false}
                        data-id={itemProgram.id}
                        bodyStyle={{
                          padding: 0,
                          boxShadow: "3px 0 16px rgba(0, 0, 0, 0.1)",
                          borderRadius: "8px",
                        }}
                      >
                        <Row style={cardStyle}>
                          <Space
                            direction={"vertical"}
                            style={{
                              borderRadius: "0",
                            }}
                          >
                            <div
                              style={{
                                width: "100%",
                                height: "150px",
                              }}
                            >
                              <Image
                                preview={false}
                                width={228}
                                height={156}
                                style={{
                                  objectFit: "cover",
                                  borderTopLeftRadius: "8px",
                                  borderTopRightRadius: "8px",
                                }}
                                src={itemProgram.thumbnail}
                                fallback={defaultImage}
                                alt="Thumbnail Program"
                              />
                            </div>
                            <Space
                              direction="vertical"
                              style={{
                                width: "100%",
                                padding: "10px 14px 14px 14px",
                              }}
                            >
                              <div
                                className="title-program"
                                style={{
                                  height: "38px",
                                  fontSize: "14px",
                                  fontWeight: "500",
                                  color: textTitleMyLearningJourney,
                                  textAlign: "left",
                                }}
                              >
                                <div
                                  className={
                                    isMobileVersion
                                      ? "break-dots-second-line"
                                      : "center-vertically-and-horizontally break-dots-second-line"
                                  }
                                  style={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  {itemProgram.name}
                                </div>
                              </div>
                              <div
                                className="desc-program break-dots-second-line"
                                style={{
                                  fontSize: "12px",
                                  height: "32px",
                                  lineHeight: "1.4",
                                  color: textDescMyLearningJourney,
                                  textAlign: "left",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: isMobileVersion ? "100%" : "200px",
                                  marginBottom: 12,
                                }}
                              >
                                {itemProgram.description}
                              </div>
                              <div>
                                <Link
                                  to={linkHref(itemProgram, "prog")}
                                  data-index={indexProgram}
                                  name={"btn-enter-program-search"}
                                >
                                  <Button
                                    className={"btn-enter-program-search"}
                                    block
                                    style={{
                                      background: ColorPrimary,
                                      color: backgroundCard,
                                      borderColor: "unset",
                                      borderRadius: "8px",
                                      fontSize: "12px",
                                      height: "29px",
                                    }}
                                  >
                                    {t("feature.feature_search.explore")}
                                  </Button>
                                </Link>
                              </div>
                            </Space>
                          </Space>
                        </Row>
                      </Card>
                    ),
                  )
                ) : (
                  <div
                    style={{
                      lineHeight: "normal",
                      fontSize: 14,
                      fontWeight: 500,
                    }}
                  >
                    {/* No “{searchVal}” in program. */}
                  </div>
                )}
              </Flex>
            </div>
          </div>
          <div style={{ marginBottom: isMobileVersion ? 28 : 40 }}>
            <div
              style={{
                fontSize: 20,
                lineHeight: "normal",
                marginBottom: dataCourseSearch.length > 0 ? 20 : 8,
                color: colorTextTitle,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  fontWeight: isMobileVersion && 400,
                  fontSize: isMobileVersion && 16,
                  color: isMobileVersion && colorTextTitleMobile,
                }}
              >
                <span
                  style={{
                    fontWeight: 500,
                    fontSize: isMobileVersion && 16,
                    color: isMobileVersion && colorTextTitleMobile,
                  }}
                >
                  {t("feature.feature_search.course")}
                </span>{" "}
                <span style={{
                  color: colorTextDesc
                }}>
                  (
                  {lengthData.course !== undefined && lengthData.course !== null
                    ? lengthData.course
                    : 0}{" "}
                  {t("feature.feature_search.found")})
                </span>
              </div>
              <div
                style={{ fontSize: 16, fontWeight: 500, color: ColorPrimary }}
              >
                <div
                  style={{
                    display:
                      lengthData.course !== undefined &&
                      lengthData.course !== null &&
                      lengthData.course > 5
                        ? "block"
                        : "none",
                  }}
                  className="btn-view-all"
                  onClick={() => onClickViewAll("course")}
                >
                  {t("feature.feature_search.view_all")}
                  {isMobileVersion && (
                    <RightOutlined
                      style={{
                        color: ColorPrimary,
                        marginLeft: "4px",
                        fontSize: 12,
                        fontaWeeight: 500,
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
            <div>
              <Flex
                className="h-100 w-100 flex-search-anchor"
                wrap="wrap"
                gap={isMobileVersion ? "16px" : "middle"}
              >
                {dataCourseSearch && dataCourseSearch.length > 0 ? (
                  dataCourseSearch &&
                  dataCourseSearch.map((itemCourse, indexCourse) =>
                    isMobileVersion ? (
                      props?.loadingAllJourney ? (
                        <Loader />
                      ) : (
                        renderCardMobile(itemCourse, indexCourse, "cour")
                      )
                    ) : (
                      <Card
                        key={indexCourse}
                        bordered={false}
                        data-id={itemCourse.id}
                        bodyStyle={{
                          padding: 0,
                          boxShadow: "3px 0 16px rgba(0, 0, 0, 0.1)",
                          borderRadius: "8px",
                        }}
                      >
                        <Row style={cardStyle}>
                          <Space
                            direction="vertical"
                            style={{ borderRadius: "0" }}
                          >
                            <div style={{ width: "100%", height: "150px" }}>
                              <Image
                                preview={false}
                                width={228}
                                height={156}
                                style={{
                                  objectFit: "cover",
                                  borderTopLeftRadius: "8px",
                                  borderTopRightRadius: "8px",
                                }}
                                src={itemCourse.thumbnail}
                                fallback={defaultImage}
                                alt={"Thumbnail Course"}
                              />
                            </div>
                            <Space
                              direction="vertical"
                              style={{
                                width: "100%",
                                padding: "10px 14px 14px 14px",
                              }}
                            >
                              <div
                                className="title-course"
                                style={{
                                  height: "38px",
                                  fontSize: "14px",
                                  fontWeight: "500",
                                  color: textTitleMyLearningJourney,
                                  textAlign: "left",
                                }}
                              >
                                <div
                                  className={
                                    isMobileVersion
                                      ? "break-dots-second-line"
                                      : "center-vertically-and-horizontally break-dots-second-line"
                                  }
                                  style={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  {itemCourse.name}
                                </div>
                              </div>
                              <div
                                className="desc-course break-dots-second-line"
                                style={{
                                  fontSize: "12px",
                                  height: "32px",
                                  lineHeight: "1.4",
                                  color: textDescMyLearningJourney,
                                  textAlign: "left",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: "200px",
                                  marginBottom: 12,
                                }}
                              >
                                {itemCourse.description}
                              </div>
                              <div>
                                <Link
                                  to={linkHref(itemCourse, "cour")}
                                  data-index={indexCourse}
                                  name={"btn-enter-course-search"}
                                >
                                  <Button
                                    className={"btn-enter-course-search"}
                                    block
                                    style={{
                                      background: ColorPrimary,
                                      color: backgroundCard,
                                      borderColor: "unset",
                                      borderRadius: "8px",
                                      fontSize: "12px",
                                      height: "29px",
                                    }}
                                  >
                                    {t("feature.feature_search.explore")}
                                  </Button>
                                </Link>
                              </div>
                            </Space>
                          </Space>
                        </Row>
                      </Card>
                    ),
                  )
                ) : (
                  <div
                    style={{
                      lineHeight: "normal",
                      fontSize: 14,
                      fontWeight: 500,
                    }}
                  >
                    {/* No “{searchVal}” in course. */}
                  </div>
                )}
              </Flex>
            </div>
          </div>
          <div>
            <div
              style={{
                fontSize: 20,
                lineHeight: "normal",
                marginBottom: dataModuleSearch.length > 0 ? 20 : 8,
                color: colorTextTitle,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  fontWeight: isMobileVersion && 400,
                  fontSize: isMobileVersion && 16,
                  color: isMobileVersion && colorTextTitleMobile,
                }}
              >
                <span
                  style={{
                    fontWeight: 500,
                    fontSize: isMobileVersion && 16,
                    color: isMobileVersion && colorTextTitleMobile,
                  }}
                >
                  {t("feature.feature_search.module")}
                </span>{" "}
                <span style={{
                  color: colorTextDesc
                }}>
                  (
                  {lengthData.module !== undefined && lengthData.module !== null
                    ? lengthData.module
                    : 0}{" "}
                  {t("feature.feature_search.found")})
                </span>
              </div>
              <div
                style={{ fontSize: 16, fontWeight: 500, color: ColorPrimary }}
              >
                <div
                  style={{
                    display:
                      lengthData.module !== undefined &&
                      lengthData.module !== null &&
                      lengthData.module > 5
                        ? "block"
                        : "none",
                  }}
                  className="btn-view-all"
                  onClick={() => onClickViewAll("module")}
                >
                  {t("feature.feature_search.view_all")}
                  {isMobileVersion && (
                    <RightOutlined
                      style={{
                        color: ColorPrimary,
                        marginLeft: "4px",
                        fontSize: 12,
                        fontaWeeight: 500,
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
            <div>
              <Flex
                className="h-100 w-100 flex-search-anchor"
                wrap="wrap"
                gap={isMobileVersion ? "16px" : "middle"}
              >
                {dataModuleSearch && dataModuleSearch.length > 0 ? (
                  dataModuleSearch &&
                  dataModuleSearch.map((itemModule, indexModule) =>
                    isMobileVersion ? (
                      props?.loadingAllJourney ? (
                        <Loader />
                      ) : (
                        renderCardMobile(itemModule, indexModule, "mod")
                      )
                    ) : (
                      <Card
                        key={indexModule}
                        bordered={false}
                        data-id={itemModule.id}
                        bodyStyle={{
                          padding: 0,
                          boxShadow: "3px 0 16px rgba(0, 0, 0, 0.1)",
                          borderRadius: "8px",
                        }}
                      >
                        <Row style={cardStyle}>
                          <Space
                            direction="vertical"
                            style={{ borderRadius: "0" }}
                          >
                            <div style={{ width: "100%", height: "150px" }}>
                              <Image
                                preview={false}
                                width={228}
                                height={156}
                                style={{
                                  objectFit: "cover",
                                  borderTopLeftRadius: "8px",
                                  borderTopRightRadius: "8px",
                                }}
                                src={itemModule.thumbnail}
                                fallback={defaultImage}
                                alt={"Thumbnail Program"}
                              />
                            </div>
                            <Space
                              direction="vertical"
                              style={{
                                width: "100%",
                                padding: "10px 14px 14px 14px",
                              }}
                            >
                              <div
                                className="title-module"
                                style={{
                                  height: "38px",
                                  fontSize: "14px",
                                  fontWeight: "500",
                                  color: textTitleMyLearningJourney,
                                  textAlign: "left",
                                }}
                              >
                                <div
                                  className={
                                    isMobileVersion
                                      ? "break-dots-second-line"
                                      : "center-vertically-and-horizontally break-dots-second-line"
                                  }
                                  style={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  {itemModule.name}
                                </div>
                              </div>
                              <div
                                className="desc-module break-dots-second-line"
                                style={{
                                  fontSize: "12px",
                                  height: "32px",
                                  lineHeight: "1.4",
                                  color: textDescMyLearningJourney,
                                  textAlign: "left",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: "200px",
                                  marginBottom: 12,
                                }}
                              >
                                {itemModule.description}
                              </div>
                              <div>
                                <Link
                                  to={linkHref(itemModule, "mod")}
                                  data-index={indexModule}
                                  name={"btn-enter-module-search"}
                                  onClick={() => dispatch(setModuleClicked(1))}
                                >
                                  <Button
                                    className={"btn-enter-module-search"}
                                    block
                                    style={{
                                      background: ColorPrimary,
                                      color: backgroundCard,
                                      borderColor: "unset",
                                      borderRadius: "8px",
                                      fontSize: "12px",
                                      height: "29px",
                                    }}
                                  >
                                    {t("feature.feature_search.explore")}
                                  </Button>
                                </Link>
                              </div>
                            </Space>
                          </Space>
                        </Row>
                      </Card>
                    ),
                  )
                ) : (
                  <div
                    style={{
                      lineHeight: "normal",
                      fontSize: 14,
                      fontWeight: 500,
                    }}
                  >
                    {/* No “{searchVal}” in module. */}
                  </div>
                )}
              </Flex>
            </div>
          </div>
        </div>
      )}
    </ConfigProvider>
  );
};

export default Search;
